import { styled } from '@goodfynd/theme';
import Divider from '@mui/material/Divider';

export const StyledCardContainer = styled('div', {
  padding: '0 1rem',
  '> .content': {
    padding: '1rem 0',
  },
  '& + &': {
    '> .content': {
      borderTop: '0.0625rem solid $BorderSubtle',
    },
  },
});

export const StyledCardContent = styled('div');

export const StyledDivider = styled(Divider, {
  '&.MuiDivider-root': {
    borderColor: 'var(--BorderNeutralSubtle)',
    borderWidth: 'thin',
    marginLeft: 0,
    marginRight: 0,
  },
});

export const StyledEmbedContainer = styled('div', {
  position: 'relative',
});

export const StyledFiltersContainer = styled('div', {
  borderBottom: '1px solid $BorderSubtle',
  display: 'flex',
  padding: 16,
});

export const StyledForm = styled('form', {
  width: '100%',
});

export const StyledInputsContainer = styled('div', {
  backgroundColor: 'var(--BackgroundBase1)',
  border: '2px solid $BorderNeutralSubtle',
  borderRadius: '0.5rem',
  display: 'flex',
  overflow: 'hidden',
  '@smMax': {
    flexDirection: 'column',
  },
  '> button, > div': {
    flex: 1,
  },
  button: {
    border: 'none',
    borderRadius: 0,
    display: 'flex',
    minWidth: '100%',
    justifyContent: 'space-between',
    padding: '0.75rem 1rem !important',
    width: '100%',
  },
  '.MuiAutocomplete-root': {
    border: 'none',
    borderRadius: 0,
    fieldset: {
      border: 'none',
    },
  },
  '> .MuiFormControl-root': {
    padding: 0,
    '.MuiOutlinedInput-root': {
      paddingRight: '2.25rem',
    },
    '.MuiAutocomplete-endAdornment': {
      right: 0,
      top: 0,
    },
  },
});

export const StyledLoadMoreContainer = styled('section', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: '1rem 0',
});

export const StyledLocation = styled('div', {
  marginTop: '0.75rem',
});

export const StyledVendorImage = styled('div', {
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  borderRadius: '0.25rem',
  height: '4.25rem',
  width: '7.5rem',
});
